module.exports = __webpack_public_path__ + "img/wheel-full.8df38872.jpg";